import { getRunTypeClassName } from '@/components/RunType.utils';
import { RunTypeIcon } from '@/components/RunTypeIcon';
import { Tooltip } from '@/design-system';
import { RunSchema } from '@/types/schema';
import { getRunTypeName } from '@/utils/get-run-type-name';
import { cn } from '@/utils/tailwind';

import css from '../styles.module.css';

export function RunType(props: {
  run: Partial<RunSchema> & Pick<RunSchema, 'name' | 'run_type'>;
  hideTooltip?: boolean;
  className?: string;
  rootRunFormat?: 'trace' | 'thread';
  isCurrentRun?: boolean;
}) {
  const isRoot = props.run.trace_id
    ? props.run.trace_id === props.run.id
    : 'parent_run_id' in props.run
    ? !props.run.parent_run_id
    : false;

  let icon = (
    <RunTypeIcon
      run={props.run}
      className="size-4"
      rootRunFormat={props.rootRunFormat}
    />
  );
  const isSingleRunRoot = isRoot && props.run.run_type !== 'thread';

  if (isSingleRunRoot) {
    icon = <>🦜</>;
  }

  return (
    <Tooltip
      title={props.hideTooltip ? undefined : getRunTypeName(props.run)}
      side="left"
    >
      <div
        className={cn(
          'p-[3px]',
          isRoot ? 'border border-brand' : getRunTypeClassName(props.run),

          css.node,
          props.run.status === 'error' && css.nodeError,
          props.className
        )}
      >
        {icon}
      </div>
    </Tooltip>
  );
}
